import {
    FETCH_ALERTS,
    FETCH_ALERTS_FAIL,
    FETCH_ALERTS_SUCCESS,
    RESET_ALERTS
} from './actionTypes';
import {
    defaultFirstPage,
    defaultItemsPerPage
} from '../../../../../services/Paging';

const initialState = {
    data: [],
    ruleCategory: '',
    dismissed: false,
    pagination: {
        pageSize: defaultItemsPerPage,
        page: defaultFirstPage,
        hasNextPage: false
    },
    sort: {
        sortType: null,
        sortOrder: null
    },
    username: null,
    jurisdictionCode: null,
    brandId: null,
    ruleType: null,
    alertLevel: null,
    error: null,
    loading: false,
    loaded: false
};

export function alertsReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_ALERTS: {
            const {
                ruleCategory,
                pagination,
                dismissed,
                sort,
                username,
                jurisdictionCode,
                brandId,
                ruleType,
                alertLevel
            } = action.payload;

            return {
                ...state,
                ruleCategory,
                dismissed,
                pagination: {
                    ...state.pagination,
                    ...pagination
                },
                sort,
                username,
                jurisdictionCode,
                brandId,
                ruleType,
                alertLevel,
                loading: true,
                loaded: false
            };
        }
        case FETCH_ALERTS_SUCCESS: {
            return {
                ...state,
                data: action.payload.result,
                pagination: {
                    ...state.pagination,
                    hasNextPage: action.payload.hasNext
                },
                loaded: true,
                loading: false
            };
        }
        case FETCH_ALERTS_FAIL: {
            return {
                ...initialState,
                error: action.payload
            };
        }
        case RESET_ALERTS: {
            return initialState;
        }
        default:
            return state;
    }
}
